export default __webpack_public_path__ + "static/appointment_scheduling-799b3999387592c6ebd6255141232d23.webp";